import { render, staticRenderFns } from "./goodsSetting.vue?vue&type=template&id=495225f4&scoped=true&"
import script from "./goodsSetting.vue?vue&type=script&lang=js&"
export * from "./goodsSetting.vue?vue&type=script&lang=js&"
import style0 from "./goodsSetting.vue?vue&type=style&index=0&id=495225f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495225f4",
  null
  
)

export default component.exports